import HomepageHero from './HomepageHero';
import compose from 'recompose/compose';
import formatPrismicData from '../../hocs/formatPrismicData';

const enhance = compose(formatPrismicData);

export default enhance(HomepageHero);
